<template>
  <div class="container">
    <div class="columns">
      <main class="column is-6 long-grass-policy">
        <LsSupportHeader :label="t('longGrass.longGrassReport.longGrassPolicy.title')" />
        <p v-for="(policy, i) in longGrassPolicy" :key="i">{{ policy }}</p>
      </main>
    </div>
  </div>
</template>

<script>
import { themedComponentMixin } from '@/mixins';
import { LsSupportHeader } from '@/views/Authorized/SupportView/components';
import { lsLongGrassHelpers } from '@/helpers';

export default {
  name: 'PolicyView',
  components: { LsSupportHeader },
  mixins: [themedComponentMixin],
  computed: {
    longGrassPolicy() {
      return lsLongGrassHelpers.getLongGrassPolicy();
    },
  },
};
</script>
<style lang="scss" scoped>
.long-grass-policy {
  & > p {
    margin: 3rem 0 2rem;
  }
}
</style>
